import { Badge } from '@/components/ui/badge';
import { Award } from 'lucide-react';
import { PROVIDER_TRUST_BADGE_LABELS, type ProviderTrustBadge } from '@/types/trainingProviders';

interface ProviderTrustBadgeProps {
  trustBadge: string | null | undefined;
}

/**
 * Small pill badge for provider trust level.
 * Renders nothing when trustBadge is null/undefined/unrecognized.
 */
export function ProviderTrustBadge({ trustBadge }: ProviderTrustBadgeProps) {
  if (!trustBadge) return null;
  const label = PROVIDER_TRUST_BADGE_LABELS[trustBadge as ProviderTrustBadge];
  if (!label) return null;

  return (
    <Badge variant="outline" className="text-xs gap-1">
      <Award className="h-3 w-3" />
      {label}
    </Badge>
  );
}
